import classNames from 'classnames'
import React from 'react'

// components
import GroupItem from 'src/components/groups/group_overview/group_list_items/group_item'
import ItemGroupHeader from 'src/components/item_group_header/item_group_header'
import LoadingSpinner from 'src/components/loading_spinner/loading_spinner'

// interfaces
import { GroupParticipationFragmentFragment, GroupPreviewFragmentFragment } from '@lopo-tech/lopo-api'

// constants
import { CLASS_PREFIX } from 'src/constants/'

import { GroupsSortingSettings } from '../../../../actions/groups/groups'
import GroupSort from '../group_sort/group_sort'
import './group_list.scss'

const cls = CLASS_PREFIX + 'group_list'

interface IGroupListProps {
  groups: GroupPreviewFragmentFragment[];
  label?: string;
  isLoading?: boolean;
  className?: string;
  onSortingChange?: (sortingSettings: GroupsSortingSettings) => void;
  sortingSettings?: GroupsSortingSettings;
  displayLastPostAt: boolean;
  ownGroupParticipation?: GroupParticipationFragmentFragment;
}

const GroupList: React.FC<IGroupListProps> = ({
  groups,
  label,
  isLoading,
  className,
  sortingSettings,
  onSortingChange,
  displayLastPostAt
}) => {
  return (
    <>
      {label && <ItemGroupHeader title={label} >
        {
          sortingSettings &&
          onSortingChange &&
          <GroupSort sortingSettings={sortingSettings} onChange={onSortingChange}/>
        }
      </ItemGroupHeader>}
      <div className={classNames(cls, className)}>
        {groups?.map((group: GroupPreviewFragmentFragment) => (
          <GroupItem
            key={group.id}
            group={group}
            displayLastPostAt={displayLastPostAt}
          />
        ))}
      </div>
      <LoadingSpinner shown={!!isLoading} />
    </>
  )
}

export default GroupList
